var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItalian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 19.9999H22V5.99995H18V19.9999H12V5.99995H8V21.4999C8 27.1881 12.3319 31.9241 18 32.8393V58.9999H22V32.8393C27.6681 31.9241 32 27.1881 32 21.4999V5.99995H28V19.9999ZM20 28.9999C16.5236 28.9999 13.5595 26.9097 12.4587 23.9999H27.5413C26.4405 26.9097 23.4764 28.9999 20 28.9999ZM51.6959 5.02332C47.6042 5.65277 43.873 7.72607 41.1774 10.8681C38.4818 14.01 37 18.0131 37 22.1529V42.9999H50V58.9999H54V4.66882L51.6959 5.02332ZM50 38.9999H41V22.1529C40.9863 19.3718 41.8482 16.6569 43.4635 14.393C45.0789 12.129 47.3657 10.4309 50 9.53907V38.9999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalian);
export default __webpack_public_path__ + "static/media/italian.400fed3c2729943502f002ad955dfa80.svg";
export { ForwardRef as ReactComponent };